import { createSlice } from "@reduxjs/toolkit";

/* LOAD CART FROM LOCAL STORAGE */

const loadCart = () => {
  try {
    const data = localStorage.getItem("cart_items");
    return data ? JSON.parse(data) : [];
  } catch {
    return [];
  }
};

/* SAVE CART */

const saveCart = (items) => {
  localStorage.setItem("cart_items", JSON.stringify(items));
};

const cartSlice = createSlice({
  name: "cart",

  initialState: {
    items: loadCart(),
  },

  reducers: {
    // ADD TO CART
    addToCart: (state, action) => {
      const newItem = action.payload;

      const existingItem = state.items.find(
        (item) =>
          item.productId === newItem.productId &&
          item.size === newItem.size &&
          item.color === newItem.color
      );

      if (existingItem) {
        existingItem.quantity += newItem.quantity;
        existingItem.subtotal =
          existingItem.price * existingItem.quantity;
      } else {
        state.items.push({
          ...newItem,
          cartId: Date.now() + Math.random(),
          subtotal: newItem.price * newItem.quantity,
        });
      }

      saveCart(state.items);
    },

    // REMOVE ITEM
    removeFromCart: (state, action) => {
      state.items = state.items.filter(
        (item) => item.cartId !== action.payload
      );

      saveCart(state.items);
    },

    // INCREASE QTY
    increaseQuantity: (state, action) => {
      const cartId = action.payload;
      const item = state.items.find((i) => i.cartId === cartId);

      if (item) {
        item.quantity += 1;
        item.subtotal = item.price * item.quantity;
      }

      saveCart(state.items);
    },

    // DECREASE QTY
    decreaseQuantity: (state, action) => {
      const cartId = action.payload;
      const item = state.items.find((i) => i.cartId === cartId);

      if (!item) return;

      item.quantity -= 1;

      if (item.quantity <= 0) {
        state.items = state.items.filter(
          (i) => i.cartId !== cartId
        );
      } else {
        item.subtotal = item.price * item.quantity;
      }

      saveCart(state.items);
    },

    // CLEAR CART
    clearCart: (state) => {
      state.items = [];
      localStorage.removeItem("cart_items");
    },
  },
});

export const {
  addToCart,
  removeFromCart,
  increaseQuantity,
  decreaseQuantity,
  clearCart,
} = cartSlice.actions;

export default cartSlice.reducer;